// extracted by mini-css-extract-plugin
export default {"header":"Crud_header__GXcdG","title":"Crud_title__Ucc2r"};